import { render, staticRenderFns } from "./ChangePreRegSubjectFromPreReg.vue?vue&type=template&id=7f88854c"
import script from "./ChangePreRegSubjectFromPreReg.vue?vue&type=script&lang=js"
export * from "./ChangePreRegSubjectFromPreReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports